"use client";

import ServiceTitle from "@/shared/app/ui/text/ServiceTitle";
import { motion, Variants } from "framer-motion";
import Image from "next/image";
import { faApple, faGooglePlay } from "@fortawesome/free-brands-svg-icons";

import { faGlobe } from "@fortawesome/pro-solid-svg-icons";
import ServiceLink from "@/shared/app/ui/link/ServiceLink";

const containerVariants: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};
const alertVariants: Variants = {
  hidden: { opacity: 0, y: 20, scale: 0.95 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.5,
      ease: "easeOut",
    },
  },
};

const YoutubeThumbnail = ({ videoId }: { videoId: string }) => {
  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;

  const handleClick = () => {
    window.open(`https://www.youtube.com/watch?v=${videoId}`, "_blank");
  };

  return (
    <div
      className="group relative w-full max-w-[996px] aspect-video cursor-pointer 
                   overflow-hidden rounded-4xl mx-auto mt-12
                   shadow-2xl shadow-black/20 transition-shadow duration-300 ease-in-out"
      onClick={handleClick}
    >
      {/* 썸네일 */}
      <Image
        src={thumbnailUrl}
        alt="유튜브 썸네일"
        fill
        sizes="(max-width: 1300px) 100vw, 1300px"
        className="object-cover transition-transform duration-700 ease-in-out group-hover:scale-[1.03]"
      />

      {/*  회색 오버레이 */}
      <div className="absolute inset-0 bg-black/30 transition-opacity duration-500 ease-in-out group-hover:opacity-60" />

      {/* 재생 버튼 컨테이너 */}
      <div className="absolute inset-0 flex justify-center items-center">
        <div
          className="w-20 h-20 bg-black/80 rounded-2xl flex justify-center items-center 
                      transition-all duration-500 ease-in-out 
                      group-hover:scale-105 group-hover:bg-black/90"
        >
          <svg
            className="w-10 h-10 text-white"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M8 5v14l11-7z" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default function WebusInfoSection() {
  return (
    <div className="border-t border-[#ECECEC] mt-[-2px]">
      <div className="w-full xl:max-w-[1280px] mx-auto px-5 xl:px-2 pt-30 md:pt-60 pb-20">
        {/* 서비스 타이틀 */}
        <ServiceTitle
          badgeText={"저상버스 탑승요청 APP"}
          title={"위버스"}
          description={`교통약자가 안심하고 이동할 수 있도록,
버스 탑승을 미리 예약해주는 서비스입니다.`}
        />

        <div className=" max-w-[996px] mx-auto text-center flex flex-col justify-center items-center mt-8 md:mt-12">
          {/* <div className="flex flex-col items-center text-center">
           
            <motion.div
              className="w-26 h-7 lg:w-42 lg:h-10 relative"
              variants={containerVariants}
              initial="hidden"
              animate="visible"
              custom={0}
            >
              <Image
                src="/assets/images/page/service/webus/logo.svg"
                alt="Symbol Logo"
                fill
                className="object-center object-cover"
              />
            </motion.div>

          
            <motion.p
              className="text-4xl md:text-5xl lg:text-8xl mt-6 lg:mt-10 text-[#0075FF] leading-11 md:leading-14 lg:leading-28 tracking-tight"
              style={{ fontFamily: '"pre-ExtraBold", sans-serif' }}
              variants={containerVariants}
              initial="hidden"
              animate="visible"
              custom={1}
            >
              저상버스 타고
              <br />
              어디로 갈까요?
            </motion.p>

      
            <motion.p
              className="tracking-tighter text-base md:text-2xl leading-5 md:leading-7 my-6 md:my-10 text-black-200"
              style={{ fontFamily: '"pre-Medium", sans-serif' }}
              variants={containerVariants}
              initial="hidden"
              animate="visible"
              custom={2}
            >
              교통약자가 버스를 더 쉽고, 더 편하게 이용할 수 있도록.
            </motion.p>
          </div> */}
          <YoutubeThumbnail videoId="UzjpB59aEi4" />

          {/* 알림창 */}
          <motion.div
            className="w-full mt-18 md:mt-24"
            variants={alertVariants}
            initial="hidden"
            animate="visible"
          >
            <div className="bg-[#3E3E3E] px-4 sm:px-8 py-5 sm:py-8 lg:px-14 lg:py-11 flex space-x-5 lg:space-x-12 items-start rounded-3xl md:rounded-4xl lg:rounded-[46px] w-full shadow-[4px_5px_8.89px_rgba(183,183,183,0.25)]">
              <div className="flex space-x-3 sm:space-x-6 lg:space-x-10 grow">
                <div className="bg-[#0075FF] aspect-square w-10 h-10 sm:w-16 lg:w-20 sm:h-16 lg:h-20 flex justify-center items-center rounded-full shrink-0">
                  <div className="w-5 h-5 sm:w-8 sm:h-8 lg:w-10 lg:h-10 relative">
                    <Image
                      src="/assets/images/page/service/webus/notificationIcon.svg"
                      alt="icon"
                      fill
                      className="object-center object-contain"
                    />
                  </div>
                </div>

                <div className="flex sm:grow flex-col text-left">
                  <p
                    className="text-base sm:text-2xl lg:text-4xl tracking-tighter text-light-10 lg:leading-11 leading-5 sm:leading-9"
                    style={{ fontFamily: '"pre-Medium", sans-serif' }}
                  >
                    저상버스 도착
                  </p>
                  <p
                    className="text-light-90 tracking-tight text-sm sm:text-xl lg:text-2xl lg:leading-8 sm:leading-6 leading-5 mt-1 sm:mt-2"
                    style={{ fontFamily: '"pre-Regular", sans-serif' }}
                  >
                    탑승 요청한 103번 버스가 잠시 후 도착합니다.
                  </p>
                </div>
              </div>

              {/* X 아이콘 - md 이상에서만 보이게 */}
              <div className="hidden md:block lg:w-8 lg:h-8 w-4 h-4 relative">
                <Image
                  src="/assets/images/page/service/webus/closeIcon.svg"
                  alt="icon"
                  fill
                  className="object-center object-contain"
                />
              </div>
            </div>
          </motion.div>
          <div className="mt-5 md:mt-10 w-full">
            <motion.div
              className="relative w-full bg-[#f6f8ff] rounded-3xl md:rounded-4xl overflow-hidden"
              initial={{ opacity: 0, y: 60 }} // 시작 상태: 아래로 살짝 내려가 있고 투명
              whileInView={{ opacity: 1, y: 0 }} // 뷰포트 안에 들어오면 부드럽게 올라옴
              transition={{
                duration: 0.9,
                ease: [0.25, 0.1, 0.25, 1], // 자연스러운 cubic-bezier 커브
              }}
              viewport={{ once: true, amount: 0.4 }} // 한 번만 실행 + 40% 노출 시 트리거
            >
              <Image
                src="/assets/images/page/service/webus/app.png"
                alt="앱 화면"
                width={374}
                height={540}
                className="w-full h-auto object-bottom object-contain"
              />
            </motion.div>
            <div className="mt-5 md:mt-14 ">
              {/* 다운로드 링크 */}
              <motion.div
                className="  flex w-full flex-col md:flex-row justify-center mt-10 md:mt-14  space-x-0 md:space-x-4 gap-y-3"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
                <ServiceLink
                  icon={faApple}
                  smallText="Available on the"
                  bigText="App Store"
                  href="https://apps.apple.com/kr/app/%EC%9C%84%EB%B2%84%EC%8A%A4-%EB%8C%80%EC%A0%84%EB%B2%84%EC%8A%A4-%EC%8B%A4%EC%8B%9C%EA%B0%84-%ED%83%91%EC%8A%B9%EC%9A%94%EC%B2%AD-%EC%A0%80%EC%83%81%EB%B2%84%EC%8A%A4/id1631103778"
                />
                <ServiceLink
                  icon={faGooglePlay}
                  smallText="GET IT ON"
                  bigText="Google Play"
                  href="https://play.google.com/store/apps/details?id=com.wezoncoop.webus&hl=ko"
                />
                <ServiceLink
                  icon={faGlobe}
                  smallText="Website link"
                  bigText="Web Site"
                  href="https://www.webus.kr/"
                />
              </motion.div>
            </div>
          </div>
        </div>
      </div>
      {/* 라운드 */}
      <div className="relative h-10 md:h-32 ">
        <div className="absolute inset-0 bg-[#2782FF] z-0" />
        <div className="absolute inset-x-0 top-0  h-10 md:h32 bg-white rounded-b-[40px] md:rounded-b-[120px] z-10 pt-10 md:pt-32" />
      </div>
    </div>
  );
}
